// extracted by mini-css-extract-plugin
module.exports = {"statusSuccess":"onboardingTemplate_statusSuccess__39EB5","confirmIcon":"onboardingTemplate_confirmIcon__1fmAx"};